export default __webpack_public_path__ + "static/media/notification.88b07923.svg";